
    <button id="fs" style="-webkit-tap-highlight-color: transparent;" (click)="onClick()">
        <img id="wha" src="{{image}}" >
        <p>
            {{text}}
        </p>
    </button>

